function initSlideshow() {
  requestAnimationFrame(() => {
    const slides = document.querySelectorAll('.slide-item');
    const dots = document.querySelectorAll('.dot');
    const prevBtn = document.querySelector('.slide-nav.prev');
    const nextBtn = document.querySelector('.slide-nav.next');
    const track = document.querySelector('.slide-track');

    if (!track || slides.length === 0) return;

    let current = 0;
    let timer;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
        if (dots[i]) dots[i].classList.toggle('active', i === index);
      });
      current = index;
    }

    function nextSlide() {
      showSlide((current + 1) % slides.length);
    }

    function prevSlide() {
      showSlide((current - 1 + slides.length) % slides.length);
    }

    function startAuto() {
      timer = setInterval(nextSlide, 5000);
    }

    function stopAuto() {
      clearInterval(timer);
    }

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        stopAuto();
        showSlide(parseInt(dot.dataset.slide));
        startAuto();
      });
    });

    if (nextBtn && prevBtn) {
      nextBtn.addEventListener('click', () => {
        stopAuto();
        nextSlide();
        startAuto();
      });

      prevBtn.addEventListener('click', () => {
        stopAuto();
        prevSlide();
        startAuto();
      });
    }

    if (track) {
      let startX = 0;
      let endX = 0;

      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });

      track.addEventListener('touchend', (e) => {
        endX = e.changedTouches[0].clientX;
        handleSwipe();
      }, { passive: true });

      function handleSwipe() {
        const threshold = 50;
        if (endX - startX > threshold) {
          stopAuto();
          prevSlide();
          startAuto();
        } else if (startX - endX > threshold) {
          stopAuto();
          nextSlide();
          startAuto();
        }
      }
    }

    showSlide(current);
    startAuto();
  });
}

document.addEventListener('DOMContentLoaded', initSlideshow);